export default __webpack_public_path__ + "static/TSD_Header_3-5cf646ea871c5019c05652e3fc558fa0.jpg";